import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { IDiscount } from "api/rpc/2024-04/facilityAdmin/product/discount";
import { CancelToken } from "axios";

type TGetDiscount = {
  id?: string | number;
  application?: string;
  auto_apply?: boolean;
  products?: boolean;
  departments?: boolean;
  customer_types?: boolean;
};

type TProductIDWithApplication = {
  product_id: number;
  application: string;
};

type IDepartmentIDWithApplication = {
  department_id: number;
  application: string;
};

type TPostDiscount = {
  title: string;
  application: "order" | "line_item";
  value_type: "percent" | "fixed_amount";
  value: number;
  custom?: boolean; // default to 0
  start_date?: string;
  end_date?: string;
  daily_start_time?: string;
  daily_end_time?: string;
  tracked?: boolean;
  auto_apply?: boolean;
  product_ids?: TProductIDWithApplication[];
  department_ids?: IDepartmentIDWithApplication[];
  customer_type_ids?: number[];

  // Enhancements
  repeat_amount: number;
  repeat_interval: string;
  week_days: Array<number>;
  schedule_type: "date_range" | "nth_weekday";
};

type TPutDiscount = {
  id: string | number;
  title?: string;
  application?: "order" | "line_item";
  value_type?: "percent" | "fixed_amount";
  value?: number;
  custom?: boolean;
  tracked?: boolean;
  auto_apply?: boolean;
  start_date: string;
  end_date: string;
  daily_start_time: string;
  daily_end_time: string;
  product_ids?: TProductIDWithApplication[];
  department_ids?: IDepartmentIDWithApplication[];
  customer_type_ids?: number[];

  // Enhancements
  repeat_amount: number;
  repeat_interval: string;
  week_days: Array<number>;
  schedule_type: "date_range" | "nth_weekday";
};

// Retrieve discount(s)
export async function GetDiscount(params?: TGetDiscount, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet<IDiscount[]>(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader, token);
}

//POST Discount
//Create a new discount
export async function PostDiscount(params?: TPostDiscount, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}

//PUT Discount
//Update an existing discount
export async function PutDiscount(params?: TPutDiscount, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}

//DELETE Discount
//Delete a discount
export async function DeleteDiscount(params?: { id: string | number }, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}
